function handleErrors(res) {
  if (res.ok || res.status === 404) {
    return res;
  } else {
    throw Error(res.statusText);
  }
}

const getJson = _ => _.json();
const options = {
  accept: 'application/json'
};
const fetchJson = url =>
  fetch(url, options)
    .then(handleErrors)
    .then(getJson);

export const fetchResults = query =>
  fetchJson(`/used-cars/api/results/query?facets=1&${query}`);

export const fetchListing = (id, postCode) => {
  const url = postCode
    ? `/used-cars/api/listing/query?sourceId=${id}&postCode=${postCode}`
    : `/used-cars/api/listing/query?sourceId=${id}`;
  return fetchJson(url);
};

export const fetchMakes = () =>
  fetchJson('/used-cars/api/results/query?facets=1&pageSize=0');

export const fetchPostcode = postcode =>
  fetchJson(`/used-cars/api/postcode/query?code=${postcode}`);



// WEBPACK FOOTER //
// ./src/App/client/api/index.js